import { render, staticRenderFns } from "./forumReports.vue?vue&type=template&id=2e81a10e&scoped=true"
import script from "./forumReports.vue?vue&type=script&lang=js"
export * from "./forumReports.vue?vue&type=script&lang=js"
import style0 from "./forumReports.vue?vue&type=style&index=0&id=2e81a10e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e81a10e",
  null
  
)

export default component.exports